// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef14c38c","239":"3c47aa90","371":"1325da09","455":"ba2b31b0"}[chunkId] + ".chunk.js";
};